interface NovelistSignetProps {
  /** Rendered height in px; width follows the mark's ratio. */
  height?: number;
}

// Paths traced from the brand toolkit's achromatic signet; the viewBox is
// cropped to the glyphs so the mark has no built-in padding.
export const NovelistSignet = ({ height = 20 }: NovelistSignetProps) => (
  <svg
    height={height}
    viewBox="89 89 353 309"
    fill="currentColor"
    aria-hidden
    focusable="false"
    style={{ display: 'block' }}
  >
    <path d="M177.11,397.27h-88.06V89.05h88.06v308.22Z" />
    <path d="M352.76,366.34l-82.45,30.93-92.78-247.36,82.45-30.93,92.78,247.36Z" />
    <path d="M441.3,397.27h-88.06V133.08h88.06v264.19Z" />
  </svg>
);
